import { useState } from "react";
import { Button, InputAdornment, Stack, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function MaintenanceToolbar({
    keyword,
    onKeywordChange,
    onNew
}) {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
                mb: 2.5,
                p: "4px 6px 4px 16px",
                backgroundColor: isFocused ? "#ffffff" : "#eef3f8",
                borderRadius: "50px",
                width: isFocused ? "380px" : "240px",
                ml: "auto",
                border: isFocused ? "1px solid #1d52bc" : "1px solid #e2e8f0",
                boxShadow: isFocused
                    ? "0 0 0 3px rgba(29, 82, 188, 0.15)"
                    : "none",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
            }}
        >
            <TextField
                size="small"
                placeholder="Search"
                value={keyword}
                onChange={(event) => onKeywordChange(event.target.value)}
                variant="standard"
                fullWidth
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                slotProps={{
                    input: {
                        disableUnderline: true,
                        startAdornment: (
                            <InputAdornment
                                position="start"
                                sx={{
                                    color: isFocused ? "#1d52bc" : "#8a99ad",
                                    mr: 1,
                                    transition: "color 0.2s ease"
                                }}
                            >
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        ),
                        sx: {
                            fontSize: "0.95rem",
                            color: "#334155",
                            fontWeight: 400,
                            "&::before, &::after": {
                                display: "none !important"
                            },
                            "& input": {
                                padding: "6px 0"
                            },
                            "& input::placeholder": {
                                color: "#8a99ad",
                                opacity: 1
                            }
                        }
                    }
                }}
            />

            <Button
                variant="contained"
                onClick={onNew}
                disableElevation
                sx={{
                    borderRadius: "50px",
                    px: 3.5,
                    py: 1,
                    minWidth: "90px",
                    fontWeight: 700,
                    fontSize: "0.85rem",
                    letterSpacing: "0.6px",
                    textTransform: "uppercase",
                    //backgroundColor: "#1d52bc",
                    whiteSpace: "nowrap"
                    /* "&:hover": {
                         backgroundColor: "#153e90"
                     }*/
                }}
            >
                New
            </Button>
        </Stack>
    );
}
